<template>
  <div id="app" :style="{height: windowsHeight}">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      windowsHeight: '200px'
    }
  },
  methods:{
    getHeight(){
      this.windowsHeight=window.innerHeight+'px';
    }
  }, 
  created(){
    window.addEventListener('resize', this.getHeight);
    this.getHeight()
  }, 
  destroyed(){
    window.removeEventListener('resize', this.getHeight)
  }
}
</script>


<style lang="scss">
//导入思源字体
@import "./common/font/SourceHanSansCN-Regular.css";

html,body{
  //height: 100%;
  border:hidden;
  overflow:auto;
  padding: 0;
  margin: 0;
  font-family:SourceHanSansCN-Regular;
}
// 屏蔽工行插件占高度问题
object#ClCache {
    display: none;
}

.level-one-max-more{
  background: #323438;
  border-color: #323438;
  color: #FFFFFF;
  transform:translateX(8px);
  .level-one-more:hover{
    cursor: pointer;
    font-size: 16px;
  }
}
.level-one-min-more{
  background: #323438;
  border-color: #323438;
  color: #FFFFFF;
  transform:translateX(15px);
  .level-one-more:hover{
    cursor: pointer;
    font-size: 16px;
  }
}
.hand-pointer:hover{
  cursor: pointer;
}

.aside-threemenu {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.aside-threemenu-ico {
  opacity: 0;
}
.aside-threemenu:hover > i{
  opacity: 1;
  color: #e6e6e6;
  font-size: 12px;
}
// 权限保存按钮和
// .right-buttongroup{
//   display: flex;
//   justify-content:space-between;
// }
//警告文字颜色
.warning-message{
  height: 25px;
  font-size:11px;
  color:red;
}
// 每个页面的主Div，上下边框保留了10px边距
.page-master{
  padding-top: 10px;
  padding-bottom: 10px;
}


//滚动条样式
::-webkit-scrollbar {
    width: 6px;
    height: 6px;
}
::-webkit-scrollbar-thumb {
    background-color: #d5d5d5;
    border-radius: 5px;
}
// 二次封装组件的通用样式
.jr-component{
  margin-top: 15px;
  position:relative;
  *display:inline; 
  *zoom:1;
  display:inline-block;
}
.jr-right-ico{      
  position:absolute;
  right:-10px;
  top: -10px;   
  font-size: 22px; 
}
.jr-right-ico:hover{
  cursor: pointer;
}
// ButtonGroup组件如果被禁用了则触发此样式
.jr-buttongroup>.el-dropdown>.el-button-group{
  pointer-events: none;
  filter: alpha(Opacity=60);
  opacity: 0.6;
}
// 表格组件单元格样式
// 主键样式
.cellPrimaryClass{
  color: #0040FF;    
}
.cellPrimaryClass:hover{
  cursor: pointer;  
}
// 删除线样式
.cellDelClass{
  text-decoration:line-through;
}
//无效、报警、未完成等样式
.cellNoExists{
  background: #f56c6c;
}
// 根据单据状态自动变换行颜色
// 审核
.rowVerifyClass {
  background: #409EFF;  
}
// input、select 表单必填项限制
.jr-checkinput input{
  border-color: red;
}
.plx-header--row{
  height: 45px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue